import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ArchetypeCard.module.css';

export interface ArchetypeCardProps {
  name: string;
  description: string;
  expandedDescription?: string;
  emoji?: string;
}

export function ArchetypeCard({ name, description, expandedDescription, emoji }: ArchetypeCardProps): JSX.Element {
  const { t } = useTranslation('flows');
  const [open, setOpen] = useState(false);
  const hasExpanded = Boolean(expandedDescription && expandedDescription.trim());

  return (
    <section className={styles.card} aria-labelledby="archetype-name">
      <div className={styles.header}>
        ✦ {t('onboarding.reveal.archetype.header').replace(/^\+\s*/, '')}
      </div>
      <div id="archetype-name" className={styles.name}>
        <em className={styles.nameEm}>{name}</em>
        {emoji ? <span aria-hidden="true"> {emoji}</span> : null}
      </div>
      <p className={styles.description}>{description}</p>
      {hasExpanded && open && (
        <p className={styles.expanded}>{expandedDescription}</p>
      )}
      {hasExpanded && (
        <button
          type="button"
          className={styles.toggle}
          aria-expanded={open}
          onClick={() => setOpen(o => !o)}
        >
          {open ? t('onboarding.reveal.archetype.showLess') : t('onboarding.reveal.archetype.readMore')}
        </button>
      )}
    </section>
  );
}
